//The Annotation Service is used to create, read, update, and delete annotations.

import { clients } from '../clients/grpcClients';
import { AnnotationServiceClient } from '../api/protosCompiled/annotation/AnnotationServiceClientPb';
import {
  Annotation,
  CreateAnnotationRequest,
  CreateAnnotationResponse,
  GetAnnotationsRequest,
  GetAnnotationsResponse,
  UpdateAnnotationResponse,
  UpdateAnnotationRequest,
  DeleteAnnotationRequest,
  DeleteAnnotationResponse,
} from './protosCompiled/annotation/annotation_pb';
import { useLocalStorage } from '../stores/localStorage';

const client = new AnnotationServiceClient(clients.host, null, {});

export class AnnotationService {
  private static getMetadata() {
    const sessionToken = useLocalStorage.getState().sessionToken;
    if (!sessionToken) {
      console.error('Session token is missing!');
    }
    return {
      sessionToken,
    };
  }

  public static createAnnotation(
    annotation: Annotation
  ): Promise<CreateAnnotationResponse.AsObject> {
    const request = new CreateAnnotationRequest();
    request.setAnnotation(annotation);
    request.setSessiontoken(this.getMetadata().sessionToken);

    return new Promise((resolve, reject) => {
      client.createAnnotation(request, {}, (err, response: CreateAnnotationResponse) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  }

  public static getAnnotations(objectId: string): Promise<GetAnnotationsResponse.AsObject> {
    const request = new GetAnnotationsRequest();
    request.setObjectid(objectId);
    request.setSessiontoken(this.getMetadata().sessionToken);

    return new Promise((resolve, reject) => {
      client.getAnnotations(request, {}, (err, response: GetAnnotationsResponse) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  }

  public static updateAnnotation(
    annotation: Annotation
  ): Promise<UpdateAnnotationResponse.AsObject> {
    const request = new UpdateAnnotationRequest();
    request.setAnnotation(annotation);
    request.setSessiontoken(this.getMetadata().sessionToken);
    return new Promise((resolve, reject) => {
      client.updateAnnotation(request, {}, (err, response: UpdateAnnotationResponse) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  }

  public static deleteAnnotation(annotationId: string): Promise<DeleteAnnotationResponse.AsObject> {
    const request = new DeleteAnnotationRequest();
    request.setId(annotationId);
    request.setSessiontoken(this.getMetadata().sessionToken);

    return new Promise((resolve, reject) => {
      client.deleteAnnotation(request, {}, (err, response: DeleteAnnotationResponse) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  }
}
